// Original GLBs and lossless appearance assets, plus a build-prepared lower-poly laptop keyboard.
export const deviceModelManifest = {
  "iphone-crm.glb": {
    "template": "/models/shared/13dc2ea0176169b0dc108bb8570d749bcaa1cd1858e4a097eba586aaddfaf249.glb",
    "iosTemplate": "/models/shared/f50533c5465398483bc492ef5efe63318de0e4947ee1a77c0358e37c2d6a42a6.bin",
    "appearance": "/models/shared/a3f3c0827093be5bed14618c46dd86f4f82e57c68a64cc783c57382ce48ff131.gltf",
    "nodes": [],
    "bounds": {
      "min": [
        -0.037604700004731116,
        -0.07735569999507964,
        -0.010363200004825742
      ],
      "max": [
        0.037604699981075525,
        0.07721599903106689,
        0.005994400001324713
      ]
    }
  },
  "iphone-hawalla.glb": {
    "template": "/models/shared/13dc2ea0176169b0dc108bb8570d749bcaa1cd1858e4a097eba586aaddfaf249.glb",
    "iosTemplate": "/models/shared/f50533c5465398483bc492ef5efe63318de0e4947ee1a77c0358e37c2d6a42a6.bin",
    "appearance": "/models/shared/364f4671bcb96ea12f88d295a5fb4bd90e5f149a53984c287fbac3143d2f54dc.gltf",
    "nodes": [],
    "bounds": {
      "min": [
        -0.037604700004731116,
        -0.07735569999507964,
        -0.010363200004825742
      ],
      "max": [
        0.037604699981075525,
        0.07721599903106689,
        0.005994400001324713
      ]
    }
  },
  "iphone-menu.glb": {
    "template": "/models/shared/13dc2ea0176169b0dc108bb8570d749bcaa1cd1858e4a097eba586aaddfaf249.glb",
    "iosTemplate": "/models/shared/f50533c5465398483bc492ef5efe63318de0e4947ee1a77c0358e37c2d6a42a6.bin",
    "appearance": "/models/shared/e5b4f1bab67c87fe95ab5e31f20c66083409244535300ea9faf3584a58ba100f.gltf",
    "nodes": [],
    "bounds": {
      "min": [
        -0.037604700004731116,
        -0.07735569999507964,
        -0.010363200004825742
      ],
      "max": [
        0.037604699981075525,
        0.07721599903106689,
        0.005994400001324713
      ]
    }
  },
  "iphone-postal.glb": {
    "template": "/models/shared/13dc2ea0176169b0dc108bb8570d749bcaa1cd1858e4a097eba586aaddfaf249.glb",
    "iosTemplate": "/models/shared/f50533c5465398483bc492ef5efe63318de0e4947ee1a77c0358e37c2d6a42a6.bin",
    "appearance": "/models/shared/314f7772456e2505c3e0233617afa65fc98f616b35a5532cfa188d33868fa734.gltf",
    "nodes": [],
    "bounds": {
      "min": [
        -0.037604700004731116,
        -0.07735569999507964,
        -0.010363200004825742
      ],
      "max": [
        0.037604699981075525,
        0.07721599903106689,
        0.005994400001324713
      ]
    }
  },
  "iphone-reference.glb": {
    "template": "/models/shared/13dc2ea0176169b0dc108bb8570d749bcaa1cd1858e4a097eba586aaddfaf249.glb",
    "iosTemplate": "/models/shared/f50533c5465398483bc492ef5efe63318de0e4947ee1a77c0358e37c2d6a42a6.bin",
    "appearance": "/models/shared/080c1cf8433b3aa2f2107c95c27110bc50d1288aa00523a010acfe49e6afeae2.gltf",
    "nodes": [],
    "bounds": {
      "min": [
        -0.037604700004731116,
        -0.07735569999507964,
        -0.010363200004825742
      ],
      "max": [
        0.037604699981075525,
        0.07721599903106689,
        0.005994400001324713
      ]
    }
  },
  "macbook-crm.glb": {
    "template": "/models/shared/ff71b2cb34a78b053eceb4cd0598d3aadd41c99b0554dd7b938afb62e96dd3f3.glb",
    "iosTemplate": "/models/shared/caa5898f73b57be1a4bbb7b7647df2ac8d33c4102bfb65a9587ae5fb24f76ca5.bin",
    "appearance": "/models/shared/5da3cebf78750dd4f8d5e5a608028603c54da893fbcc429d1791b1349e0e507a.gltf",
    "nodes": [],
    "optimizedTemplate": "/models/shared/73d8d1672e582ea5279f7601030fc096627ca7ac4d7e36b6195811e08134ba88.bin",
    "bounds": {
      "min": [
        -0.17805399998599586,
        -0.04806949996972084,
        -0.15299294420778833
      ],
      "max": [
        0.17805399998599586,
        0.18825173638676945,
        0.1492122999894023
      ]
    }
  },
  "macbook-hawalla.glb": {
    "template": "/models/shared/ff71b2cb34a78b053eceb4cd0598d3aadd41c99b0554dd7b938afb62e96dd3f3.glb",
    "iosTemplate": "/models/shared/caa5898f73b57be1a4bbb7b7647df2ac8d33c4102bfb65a9587ae5fb24f76ca5.bin",
    "appearance": "/models/shared/55ddf6c5736b98ee960aa6be2ff6778d431691ce1a4d12dad208c0e565ae8339.gltf",
    "nodes": [],
    "optimizedTemplate": "/models/shared/73d8d1672e582ea5279f7601030fc096627ca7ac4d7e36b6195811e08134ba88.bin",
    "bounds": {
      "min": [
        -0.17805399998599586,
        -0.04806949996972084,
        -0.15299294420778833
      ],
      "max": [
        0.17805399998599586,
        0.18825173638676945,
        0.1492122999894023
      ]
    }
  },
  "macbook-menu.glb": {
    "template": "/models/shared/ff71b2cb34a78b053eceb4cd0598d3aadd41c99b0554dd7b938afb62e96dd3f3.glb",
    "iosTemplate": "/models/shared/caa5898f73b57be1a4bbb7b7647df2ac8d33c4102bfb65a9587ae5fb24f76ca5.bin",
    "appearance": "/models/shared/15eef4ac0ea9dcf8f5339b277763d6a91abe0be24d7e03bf326b8388251849c8.gltf",
    "nodes": [],
    "optimizedTemplate": "/models/shared/73d8d1672e582ea5279f7601030fc096627ca7ac4d7e36b6195811e08134ba88.bin",
    "bounds": {
      "min": [
        -0.17805399998599586,
        -0.04806949996972084,
        -0.15299294420778833
      ],
      "max": [
        0.17805399998599586,
        0.18825173638676945,
        0.1492122999894023
      ]
    }
  },
  "macbook-postal.glb": {
    "template": "/models/shared/ff71b2cb34a78b053eceb4cd0598d3aadd41c99b0554dd7b938afb62e96dd3f3.glb",
    "iosTemplate": "/models/shared/caa5898f73b57be1a4bbb7b7647df2ac8d33c4102bfb65a9587ae5fb24f76ca5.bin",
    "appearance": "/models/shared/b0c52b2cd0b1b6fc56c2ead478b967f66ab7726fbfb90ab3e1a49476c869cdbb.gltf",
    "nodes": [],
    "optimizedTemplate": "/models/shared/73d8d1672e582ea5279f7601030fc096627ca7ac4d7e36b6195811e08134ba88.bin",
    "bounds": {
      "min": [
        -0.17805399998599586,
        -0.04806949996972084,
        -0.15299294420778833
      ],
      "max": [
        0.17805399998599586,
        0.18825173638676945,
        0.1492122999894023
      ]
    }
  },
  "macbook-web.glb": {
    "template": "/models/shared/ff71b2cb34a78b053eceb4cd0598d3aadd41c99b0554dd7b938afb62e96dd3f3.glb",
    "iosTemplate": "/models/shared/caa5898f73b57be1a4bbb7b7647df2ac8d33c4102bfb65a9587ae5fb24f76ca5.bin",
    "appearance": "/models/shared/9897bb0d50943235fbb579282db85e8f08ef2afa94a61ed34a5176b005785f25.gltf",
    "nodes": [
      {
        "index": 170,
        "matrix": [
          1,
          0,
          0,
          0,
          0,
          0.9902680687415704,
          -0.1391731009600654,
          0,
          0,
          0.1391731009600654,
          0.9902680687415704,
          0,
          0,
          -1.48,
          -3.72,
          1
        ]
      }
    ],
    "optimizedTemplate": "/models/shared/73d8d1672e582ea5279f7601030fc096627ca7ac4d7e36b6195811e08134ba88.bin",
    "bounds": {
      "min": [
        -0.17805399998599586,
        -0.04806949996972084,
        -0.12918738785319628
      ],
      "max": [
        0.17805399998599586,
        0.19264050277293643,
        0.1492122999894023
      ]
    }
  }
};
